import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <main class="app-shell">
      <router-outlet></router-outlet>
    </main>
  `,
  styles: [
    `
    .app-shell {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0;
    }
    `
  ]
})
export class AppComponent {}
